<template>
  <TheFieldset legend="Filter Waivers">
    <div class="filters">
      <TheDatePicker
        v-model="state.from"
        label="From:"
        class="date"
      />
      <TheDatePicker
        v-model="state.to"
        label="To:"
        class="date"
      />
      <button
        class="black-btn"
        type="button"
        @click="submitFilters()"
      >
        Search
      </button>
      <button
        class="black-btn"
        type="button"
        @click="clearFilters()"
      >
        Clear Filters
      </button>
    </div>
  </TheFieldset>
</template>

<script setup>
import { reactive } from 'vue';
import TheFieldset from '@/components/global/TheFieldset.vue';
import TheDatePicker from '@/components/global/TheDatePicker.vue';

const state = reactive({
  from: '',
  to: '',
});

const emit = defineEmits(['filter']);

const clearFilters = () => {
  state.from = '';
  state.to = '';

  emit('filter', state);
};

const submitFilters = () => {
  emit('filter', state);
};
</script>

<style lang="scss" scoped>
.filters {
  display: flex;
  align-items: end;
  gap: 10px;

  & > :deep(div) {
    flex: 2;
  }
}
</style>
